import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import type { AccountStatus } from '../types';
import {
  StatusSelect,
  ReasonInput,
  ConfirmCheck,
} from './status-override-inputs';

type FS = { status: AccountStatus; reason: string; confirmed: boolean };
type Props = {
  s: FS;
  setS: (s: FS) => void;
  current: AccountStatus;
  isPending: boolean;
  onSubmit: () => void;
};

function useFormLogic(s: FS, current: AccountStatus) {
  const isBan = s.status === 'banned' && current !== 'banned';
  const isUnban = s.status !== 'banned' && current === 'banned';
  const needs = isBan || isUnban;
  const can =
    s.status !== current &&
    s.reason.trim().length > 0 &&
    (!needs || s.confirmed);
  const label = isBan
    ? 'Confirmo banear permanentemente'
    : 'Forzar reactivación';
  return { needs, can, label };
}

export function StatusOverrideForm(p: Props): ReactNode {
  const { needs, can, label } = useFormLogic(p.s, p.current);
  return (
    <>
      <StatusSelect
        value={p.s.status}
        onChange={(v) => p.setS({ ...p.s, status: v })}
      />
      <ReasonInput
        value={p.s.reason}
        onChange={(v) => p.setS({ ...p.s, reason: v })}
      />
      {needs && <ConfirmCheck s={p.s} setS={p.setS} label={label} />}
      <Button size="sm" onClick={p.onSubmit} disabled={!can || p.isPending}>
        Aplicar cambio
      </Button>
    </>
  );
}
